<template>
  <section id="appointment" class="testimonial-wrap pb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <div class="section-title style3 mb-40">
            <span>Testimonials</span>
            <h2>
              Read Our <span>Medical Clinic</span> Clients Reviews Discovered
            </h2>
          </div>
          <Carousel
            :autoplay="5000"
            :wrap-around="true"
            pause-autoplay-on-hover
            class="testimonial-slider-two"
          >
            <Slide v-for="testimonial in testimonials" :key="testimonial.id">
              <div class="testimonial-card style3">
                <ul class="ratings list-style">
                  <li><i class="ri-star-fill"></i></li>
                  <li><i class="ri-star-fill"></i></li>
                  <li><i class="ri-star-fill"></i></li>
                  <li><i class="ri-star-fill"></i></li>
                  <li><i class="ri-star-half-line"></i></li>
                </ul>
                <p class="client-quote">
                  {{ testimonial.shortDesc }}
                </p>
                <div class="client-info-area">
                  <div class="client-info-wrap">
                    <div class="client-img">
                      <img :src="testimonial.image" alt="Image" />
                    </div>
                    <div class="client-info">
                      <h3>{{ testimonial.name }}</h3>
                      <span>{{ testimonial.designation }}</span>
                    </div>
                  </div>
                  <div class="quote-icon">
                    <i class="flaticon-quote-1"></i>
                  </div>
                </div>
              </div>
            </Slide>

            <template #addons>
              <Pagination />
            </template>
          </Carousel>
        </div>

        <div class="col-lg-6">
          <div class="book-appointment style2">
            <h5>Book An Online Appointment</h5>
            <form action="#">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <input type="text" placeholder="Full Name" />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <input type="text" placeholder="Email Address" />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <input type="number" placeholder="Phone Number" />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Booking Date"
                      onfocus="(this.type='date')"
                      onblur="(this.type='text')"
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <select name="dept" id="dept">
                      <option data-display="Select Department" value="0">
                        Department
                      </option>
                      <option value="1">Dental Health</option>
                      <option value="2">Physical Health</option>
                    </select>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <select name="doc" id="doc">
                      <option data-display="Select Doctor" value="0">
                        Select Doctor
                      </option>
                      <option value="1">Dr. Josef Henry</option>
                      <option value="2">Dr. Kevin Martin</option>
                    </select>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <select name="location" id="location">
                      <option data-display="Select Location" value="0">
                        Select Location
                      </option>
                      <option value="1">South Arizona</option>
                      <option value="2">Florida</option>
                    </select>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <textarea
                      name="msg"
                      id="msg"
                      cols="30"
                      rows="10"
                      placeholder="Message"
                    ></textarea>
                  </div>
                </div>

                <div class="col-12">
                  <button type="submit" class="btn style2">
                    Book An Appointment
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "OurTestimonials",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    testimonials: [
      {
        id: 1,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has orem ipsum dolor sit amet consec tetur adipisicing elitae amet sit dolor.”",
        image: require("../../assets/images/testimonials/client-3.jpg"),
        name: "Jim Morison",
        designation: "Director, BAT",
      },
      {
        id: 2,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has orem ipsum dolor sit amet consec tetur adipisicing elitae amet sit dolor.”",
        image: require("../../assets/images/testimonials/client-2.jpg"),
        name: "Alex Cruis",
        designation: "CEO, IBAC",
      },
      {
        id: 3,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has orem ipsum dolor sit amet consec tetur adipisicing elitae amet sit dolor.”",
        image: require("../../assets/images/testimonials/client-3.jpg"),
        name: "Tom Haris",
        designation: "Engineer, Olleo",
      },
      {
        id: 4,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has orem ipsum dolor sit amet consec tetur adipisicing elitae amet sit dolor.”",
        image: require("../../assets/images/testimonials/client-4.jpg"),
        name: "Harry Jackson",
        designation: "Enterpreneur",
      },
    ],
  }),
});
</script>